import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { forwardRef, memo } from "react";
import { useAssetModalPanelContext } from "~/providers/AssetModalPanelContextProvider";
import { useMobileAssetModalContext } from "~/providers/MobileAssetModalContextProvider";
export const MobileAssetModalPanelHeader = /*#__PURE__*/ memo(/*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { title } = param;
    const { navigationHeight } = useMobileAssetModalContext();
    const { hidePanel } = useAssetModalPanelContext();
    return /*#__PURE__*/ _jsxs("header", {
        className: "sticky top-10 z-1 flex shrink-0 items-center justify-between gap-2 border-y border-grey-5 bg-grey-1 px-6 py-4",
        style: {
            top: navigationHeight
        },
        ref: forwardedRef,
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "text-14 font-bold uppercase tracking-wide text-grey-10",
                children: title
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                appearance: "ghost",
                color: "grey",
                icon: Close,
                label: "Close panel",
                onClick: hidePanel,
                size: "medium"
            })
        ]
    });
}));
MobileAssetModalPanelHeader.displayName = "MobileAssetModalPanelHeader";
